export default __webpack_public_path__ + "static/media/sportsbooks.951637c0.png";